import React from 'react';
import LOOKUP from 'constants/lookup';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeaderWithClose from '../../../../components/basic/DialogHeaderWithClose';

const RewardPoint = (props) => {
    return (
        <DialogInput
            title={<DialogHeaderWithClose text="Points" handleClose={() => props.closePoints()}/>}
            className="checkIn_list"
            modal={true}
            autoScrollBodyContent={true}
            handleClose={() => props.closePoints()}
            open={props.openDiag}
            >
            <div>
                <Button name="buttonCancel"
                    type="Button"
                    className="corner_X"
                    label=""
                    onTouchTap={() => props.closePoints()}
                />
            </div>
            {
                props.isPOS ?
                <div>
                    <div className="row">
                        <div className="col-lg-12">
                        <br />
                        <div className="alert alert-danger">
                            <p>An approval by the management team is necessary to add or deduct points, please ask for management team to approve this change.</p>
                        </div>
                        </div>
                    </div>
                    <h4 className="purpleText">{LOOKUP.pos.applyDiscountDialog.credentialsTitle}</h4>
                    <div className="row">
                        <div className="col-lg-6">
                        <TextInput name={`POSRewardUsername`}
                            fullWidth={true}
                            label={LOOKUP.pos.applyDiscountDialog.userName.label}
                            floatingLabelText={LOOKUP.pos.applyDiscountDialog.userName.label}
                            hintText={LOOKUP.pos.applyDiscountDialog.userName.hintText} />
                        </div>
                        <div className="col-lg-6">
                        <TextInput name={`POSRewardPassword`}
                            type="password"
                            fullWidth={true}
                            label={LOOKUP.pos.applyDiscountDialog.password.label}
                            floatingLabelText={LOOKUP.pos.applyDiscountDialog.password.label}
                            hintText={LOOKUP.pos.applyDiscountDialog.password.hintText} />
                        </div>
                    </div>
                    <div>
                        <h4 className="purpleText">Or By {LOOKUP.pos.applyDiscountDialog.pincodeTitle}</h4>
                        <div className="row">
                        <div className="col-lg-12">
                            <TextInput name={`POSRewardPinCode`} hintText="Password" fullWidth={true} type="password" maxLength={4} autoComplete="off" />
                        </div>
                        </div>
                    </div>
                </div> : null
            }


            <div className="pt-2" >
                <TextInput className="pointsInput"
                    name="Amount"
                    type="number"
                    label="Amount"
                    floatingLabelText="Amount"
                    hintText="Amount"
                    fullWidth={true}
                    maxLength={10} />

                <TextInput className="commentInput"
                    name="Comment"
                    label="Comments"
                    floatingLabelText="Comments"
                    hintText="Comments"
                    rows={1}
                    maxLength={200}
                    fullWidth={true} />

                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pb-2 pt-1 text-right">
                    <Button
                        type="IconDeleteButton"
                        label="Deduct"
                        className="btn-danger"
                        onTouchTap={() => props.removeRewardPoints()}
                    />
                    <Button
                        type="IconAddButton"
                        className="ml-2 btnNewBrandPOS"
                        onTouchTap={() => props.addRewardPoints()}
                    />
                </div>
            </div>
        </DialogInput>
    );
};

export default RewardPoint;
